<template lang="pug">
  .employee-cv
    .section
      .container
        a.back(@click="$router.push(back)" v-if="(previous || {}).name === 'Workers'") <&#160; {{ gettext('Back to search') }}
        a.back(@click="$router.back()" v-else) <&#160; {{ gettext('Back to previous page') }}
        .tile.is-ancestor
          .tile.is-parent.is-10.cv-wrap
            h2 {{ gettext('Employee’s profile') }}
            profile(:cv="cv" :package="package" @update="getCV")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { gettext } from '@/services/TranslateHandler'
import Profile from './parts/profile'
import mixin from '@/mixins'
const toastr = require('toastr')
const CONSTANTS = require('@/constants.json')
const _ = require('lodash')

export default {
  name: 'CV',
  mixins: [
    mixin
  ],
  components: {
    Profile
  },
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo})
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getPublicCV({lang: vm.getLanguage, id: parseInt(vm.$route.params.id)}).then(res => {
        vm.cv = res
      }).catch(err => {
        if ((err.data.error || {}).message) {
          toastr.warning(err.data.error.message, 'Warning')
        }
        vm.$router.push({name: 'Workers', params: {lang: vm.getLanguage}})
      })
    })
  },
  data () {
    return {
      cv: {},
      CONSTANTS: CONSTANTS,
      package: null,
      previous: this.$route.params.previous
    }
  },
  methods: {
    gettext: gettext,
    ...mapActions([
      'getPublicCV'
    ]),
    getCV () {
      this.getPublicCV({lang: this.getLanguage, id: parseInt(this.$route.params.id)}).then(res => {
        this.cv = res
      })
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage',
      'getFinanceAccount'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Bixter | ' + gettext('Employee'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    },
    back () {
      if (this.previous) return _.omit(this.previous, ['path'])
      else return {name: 'Workers', params: {lang: this.getLanguage}}
    }
  },
  watch: {
    getLanguage: function () {
      this.getCV()
    }
  }
}
</script>

<style lang='scss' src='./styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/cv/index.vue